import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "../assets/css/ContactForm.css";

const ContactWorkForm = ({ show, handleClose }) => {

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [doc, setDoc] = useState(null);
  const [isChecked, setIsChecked] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isChecked) {
      alert("Você precisa concordar com os termos para continuar.");
      return;
    }
    alert("Formulário enviado com sucesso!");

    const templateParams = {
      name,
      email,
      phone,
      message,
    };

    try {
      const response = await axios.post("https://gaotech.com.br/envio-email/envio-email.php", templateParams, {
        headers: {
          "Content-Type": "application/json", // Cabeçalho indicando JSON
        },
        withCredentials: false, // Incluir cookies, se necessário
      });

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: "E-mail enviado com sucesso.",
        });
        handleClose();
      } else {
        Swal.fire({
          icon: "error",
          title: "Erro!",
          text: response.data.message || "Erro ao enviar o e-mail.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Erro de Conexão!",
        text: "Não foi possível conectar à API. Verifique sua conexão ou tente novamente mais tarde.",
      });
      console.error("Erro ao conectar com a API:", error);
    }
  };

  const formatPhone = (value) => {
    value = value.replace(/\D/g, ""); // Remove tudo que não for número
    value = value.replace(/^(\d{2})(\d)/g, "($1) $2"); // Coloca parênteses nos dois primeiros dígitos
    value = value.replace(/(\d{5})(\d)/, "$1-$2"); // Adiciona o hífen
    return value;
  };



  return (
    <div className={`modal fade custom-modal ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1" role="dialog">
      <div className="modal-dialog padding-top-19" role="document">
        <div className="modal-content alter-modal">
          <div className="modal-header">
            <p className="modal-custom-title ">Trabalhe conosco</p>
          </div>
          <div className="modal-body text-start  ">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="formName">Nome Completo</label>
                <input
                  type="text"
                  className="form-control style-input"
                  id="formName"
                  name="name"
                  placeholder="Nome"
                  maxLength={60}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="form-group margin-32">
                <label htmlFor="formPhone">Telefone</label>
                <input
                    type="text"
                    className="form-control style-input"
                    id="formPhone"
                    name="phone"
                    placeholder="(DDD) 9 9999-9999"
                    maxLength={15}
                    value={phone}
                    onChange={(e) => setPhone(formatPhone(e.target.value))}
                    required
                />
              </div>
              <div className="form-group margin-32 ">
                <label htmlFor="formEmail">E-mail Coorporativo</label>
                <input
                  type="email"
                  className="form-control style-input"
                  id="formEmail"
                  name="email"
                  placeholder="exemplo@email.com"
                  maxLength={80}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="form-group margin-32  ">
                <label htmlFor="formMessage">Resumo do seu currículo</label>
                <textarea
                  className="form-control"
                  id="formMessage"
                  name="message"
                  maxLength={4000}
                  placeholder="Digite a sua necessidade"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  rows={3}
                  required
                />
              </div>
              <div className="form-group margin-32">
                <label htmlFor="formDoc">Anexe seu currículo (PDF - max:5MB)</label>
                <input
                    className="form-control"
                    id="formDoc"
                    name="doc"
                    type="file"
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => setDoc(e.target.files[0])}
                    required
                />
              </div>
              <div className="form-group margin-32 text-align-center">
                <input
                    type="checkbox"
                    id="terms"
                    checked={isChecked}
                    onChange={(e) => setIsChecked(e.target.checked)}
                    required
                    className="custom-checkbox"
                />
                <label htmlFor="terms">
                  Eu concordo com os <a href="/termos">Termos</a> & <a href="/permissoes">Permissões</a>
                </label>
              </div>
              <div className="btnActions margin-32">
                <button type="button" className="btn-cancel width-140" onClick={handleClose} aria-label="Close">
                  Cancelar
                </button>
                {/*esse botão so pode ser enabled se for true*/}
                <button type="submit" disabled={!isChecked} className="btn-next width-140">Enviar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactWorkForm;